const {
  VUE_APP_API_RM_HS,
  VUE_APP_API_RM_HK,
  VUE_APP_API_RM_US,
  VUE_APP_API_F10_HS,
  VUE_APP_API_F10_HK,
  VUE_APP_API_F10_US,
  VUE_APP_API_SDK_HS,
  VUE_APP_API_SDK_HK,
  VUE_APP_API_SDK_US,
  VUE_APP_API_F10_AUTH_URL,
  VUE_APP_API_F10_AUTH_NAME,
  VUE_APP_API_F10_AUTH_ID,
  VUE_APP_API_F10_AUTH_TTL,
  VUE_APP_API_F10_AUTH_KEY,
  VUE_APP_API_F10_AUTH_SECRET,
  VUE_APP_API_SDK_AUTH_URL,
  VUE_APP_API_SDK_AUTH_APPID,
  VUE_APP_API_SDK_AUTH_SECRET,
  VUE_APP_API_SDK_AUTH_EXPIRESIN,
  VUE_APP_API_NEWS,
  VUE_APP_API_BASE_HK,
  VUE_APP_API_JP,
  VUE_APP_WS_JP,
  VUE_APP_API_RM_NEWS
  // VUE_APP_DEBUG
} = process.env

export function getDebugSettings() {
  // 当前只有日股资金成交统计需要做推送，后面可扩展
  return 'f10:*'
}

export function getWsJpAddress() {
  return VUE_APP_WS_JP
}

export function getWsHkAddress() {
  // 待补充...
  return ''
}

export function getWsHsAddress() {
  // 待补充...
  return ''
}

export function getWsUsAddress() {
  // 待补充...
  return ''
}

export function getWsUsOptionAddress() {
  // 待补充...
  return ''
}

export function getWsUsOtcAddress() {
  // 待补充...
  return ''
}

export default {
  rm: {
    hs: VUE_APP_API_RM_HS,
    hk: VUE_APP_API_RM_HK,
    us: VUE_APP_API_RM_US,
    jp: VUE_APP_API_JP,
    news: VUE_APP_API_RM_NEWS
  },
  f10: {
    hs: VUE_APP_API_F10_HS,
    hk: VUE_APP_API_F10_HK,
    us: VUE_APP_API_F10_US
  },
  sdk: {
    hs: VUE_APP_API_SDK_HS,
    hk: VUE_APP_API_SDK_HK,
    us: VUE_APP_API_SDK_US,
    jp: VUE_APP_API_JP
  },
  f10auth: {
    url: VUE_APP_API_F10_AUTH_URL,
    name: VUE_APP_API_F10_AUTH_NAME,
    id: VUE_APP_API_F10_AUTH_ID,
    ttl: VUE_APP_API_F10_AUTH_TTL,
    key: VUE_APP_API_F10_AUTH_KEY,
    secret: VUE_APP_API_F10_AUTH_SECRET
  },
  sdkauth: {
    url: VUE_APP_API_SDK_AUTH_URL,
    appId: VUE_APP_API_SDK_AUTH_APPID,
    secret: VUE_APP_API_SDK_AUTH_SECRET,
    expiresIn: VUE_APP_API_SDK_AUTH_EXPIRESIN
  },
  news: VUE_APP_API_NEWS,
  base: {
    hk: VUE_APP_API_BASE_HK
  }
}
